import React, { Component } from 'react'
import store from './store'
import { observer } from 'mobx-react'
import { Input, Button } from 'hljd'
import styles from '../style.module.less'
import { HeaderView } from '@merchant-backend/common-components'

@observer
export default class extends Component {
  componentDidMount() {
    store.getStatus()
    store.getGift()
  }

  render() {
    const { gift_content, gift_status, gift_reason } = store
    let header = [
      <a href="#/localMerchant/marketingTools?key=1">到店礼</a>,
      '设置到店礼'
    ]
    return (
      <HeaderView header={header} title="设置到店礼">
        <div className={styles.box}>
          {(gift_status == 3 || gift_status == 4) && (
            <div className={styles.pendingMsg}>
              <img src="http://qnm.hunliji.com/o_1b3c9uqm9am31qpf1rd9qr1c437.png" />
              {gift_status == 3 && (
                <span>审核中！在审核结束后，您将收到我们的通知</span>
              )}
              {gift_status == 4 && <span>{gift_reason}</span>}
            </div>
          )}

          <span className={styles.must}>到店礼</span>
          <Input
            style={{ width: 300 }}
            value={gift_content}
            onChange={store.changeValue}
          />
          <span className={styles.num}>
            <span style={{ color: '#999' }}>
              {15 - (gift_content || '').length}
            </span>/15
          </span>

          <Button
            type="primary"
            style={{ float: 'right' }}
            onClick={store.saveGift}
          >
            保存
          </Button>

          <p style={{ color: '#999', paddingLeft: 4, marginTop: 10 }}>
            例如：免费专车接您探店；青花瓷餐具
            （注：前端展示自带“预约到店即送”的字样，填写内容无需添加“送”、“预约即送”等字样）
          </p>
        </div>
      </HeaderView>
    )
  }
}
